export function camelCase(str) {
  if (str === void 0) {
    str = '';
  }

  return str.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
}